module.exports = __webpack_public_path__ + "fonts/FuturaStd-Book.ece28e0f.woff";